import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { SharedModule } from 'src/app/shared/shared.module';
import { TrucksService } from 'src/app/transportation';
import { MatButtonModule } from '@angular/material/button';
@Component({
  selector: 'app-truck-toolbar',
  imports: [SharedModule, MatButtonModule],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './truck-toolbar.component.html',
})

export class TruckToolbarComponent {
  url!: string;
  excelExporting?: (service: TrucksService) => void;

  constructor(
    private _router: Router,
    private _truckService: TrucksService
  ) { }

  add() {
    this._router.navigate([this.url]);
  }

  excelExport() {
    if(this.excelExporting) {
      this.excelExporting(this._truckService);
    }
  }
}